/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthRefreshTokenResponse } from './AuthRefreshTokenResponse';

export type AuthRefreshTokenResponseApiRespoonse = {
    data?: AuthRefreshTokenResponse;
    status?: AuthRefreshTokenResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuthRefreshTokenResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

